<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'

export interface WidgetArticlesData {
    title: string;
    subtitle?: string;
    data: BlogPost[];
}
export interface WidgetArticlesProps {
    data: WidgetArticlesData;
    headingLevel: HeadingLevel;
    // Optional override for heading to avoid duplicate headings (WCAG 2.4.6)
    headingOverride?: string;
}

const props = withDefaults(defineProps<WidgetArticlesProps>(), {
    headingOverride: undefined,
})

// Use override if provided, otherwise fall back to data title
const displayHeading = computed(() => props.data.title)
const { $t } = useNuxtApp()
const showAllArticles = $t('Zobraziť všetky články')
</script>

<template>
  <Box
    decor-position="top-right"
    color="gray"
    class="rounded pt-12"
    data-cy="widget_articles"
  >
    <Tracker :data="{ position: displayHeading }">
      <BoxHeader
        :heading="displayHeading"
        :heading-level="props.headingLevel"
        :subtitle="props.data.subtitle"
      >
        <template #tag>
          <Tag
            class="text-uppercase"
            :decor="false"
            size="small"
            background-color="white"
          >
            {{ $t('Magazín Kooperativa') }}
          </Tag>
        </template>
      </BoxHeader>
      <Slider
        data-cy="widget_articles_slider"
      >
        <SplideSlide
          v-for="(article, index) in props.data.data"
          :key="`wai-${index}`"
          :has-track="false"
          class="pt-2"
        >
          <Tracker :data="{ title: article.title }">
            <ArticleBox
              :data="article"
              link-type="magazine"
              :alt-switch="false"
            />
          </Tracker>
        </SplideSlide>
      </Slider>
      <div class="d-flex justify-content-center mt-6">
        <VButton
          :to="{ name: 'magazine' }"
          size="large"
          color="primary"
          :label="showAllArticles"
        >
          {{ showAllArticles }}
        </VButton>
      </div>
    </Tracker>
  </Box>
</template>
